import { render, staticRenderFns } from "./EditRecShareAdminDlg.vue?vue&type=template&id=f3868a62&scoped=true"
import script from "./EditRecShareAdminDlg.vue?vue&type=script&lang=js"
export * from "./EditRecShareAdminDlg.vue?vue&type=script&lang=js"
import style0 from "./EditRecShareAdminDlg.vue?vue&type=style&index=0&id=f3868a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3868a62",
  null
  
)

export default component.exports